/* ============================================================
   SCENT LEGACY — THEME JS
   Vanilla JS. No frameworks.
   ============================================================ */

'use strict';

/* ── Utility ── */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];
const on = (el, ev, fn, opts) => el && el.addEventListener(ev, fn, opts);

/* ── Scroll-triggered fade-in ── */
function initFadeIn() {
  const els = $$('.fade-in');
  if (!els.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('visible'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  els.forEach(el => io.observe(el));
}

/* ── Header: scroll state ── */
function initHeader() {
  const header = $('.site-header');
  if (!header) return;
  const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 20);
  on(window, 'scroll', onScroll, { passive: true });
  onScroll();
}

/* ── Mobile nav ── */
function initMobileNav() {
  const toggle = $('.mobile-menu-toggle');
  const nav = $('.mobile-nav');
  if (!toggle || !nav) return;
  on(toggle, 'click', () => {
    toggle.classList.toggle('open');
    nav.classList.toggle('open');
    document.body.style.overflow = nav.classList.contains('open') ? 'hidden' : '';
  });
  $$('.mobile-nav__link').forEach(link => {
    on(link, 'click', () => {
      toggle.classList.remove('open');
      nav.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
}

/* ── Cart Drawer ── */
function initCartDrawer() {
  const drawer = $('.cart-drawer');
  const overlay = $('.cart-drawer-overlay');
  const openBtns = $$('[data-cart-trigger]');
  const closeBtn = $('.cart-drawer__close');

  const open = () => {
    drawer?.classList.add('open');
    overlay?.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  const close = () => {
    drawer?.classList.remove('open');
    overlay?.classList.remove('open');
    document.body.style.overflow = '';
  };

  openBtns.forEach(btn => on(btn, 'click', open));
  on(closeBtn, 'click', close);
  on(overlay, 'click', close);
  on($('#cart-continue'), 'click', close);
  on(document, 'keydown', e => { if (e.key === 'Escape') close(); });
}

/* ── Product: Quantity ── */
function initQuantity() {
  $$('.quantity-selector').forEach(selector => {
    const input = selector.querySelector('.quantity-input');
    const minus = selector.querySelector('[data-minus]');
    const plus  = selector.querySelector('[data-plus]');
    if (!input) return;
    on(minus, 'click', () => { if (+input.value > 1) input.value = +input.value - 1; });
    on(plus,  'click', () => { input.value = +input.value + 1; });
  });
}

/* ── Product: Tabs ── */
function initTabs() {
  $$('.tab-nav').forEach(nav => {
    const btns = $$('.tab-btn', nav);
    const panel = nav.closest('.product-tabs');
    btns.forEach(btn => {
      on(btn, 'click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const target = btn.dataset.tab;
        $$('.tab-panel', panel).forEach(p => {
          p.classList.toggle('active', p.dataset.panel === target);
        });
      });
    });
  });
}

/* ── Size selector (respects pre-marked active for 5ml default) ── */
function initSizeSelector() {
  $$('.size-selector').forEach(sel => {
    const btns = $$('.size-btn', sel);
    const getCard = btn => btn.closest('[data-price-target]') || btn.closest('.decant-card') || btn.closest('.product-single__info');
    const updatePrice = btn => {
      const priceEl = getCard(btn)?.querySelector('[data-dynamic-price]');
      if (priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
    };
    btns.forEach(btn => {
      on(btn, 'click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        updatePrice(btn);
        // Product page: update hidden variant input, price, and size label
        const variantInput = document.getElementById('variant-id-input');
        if (variantInput && btn.dataset.variantId) {
          variantInput.value = btn.dataset.variantId;
        }
        const priceDisplay = $('.product-single__price [itemprop="price"]');
        if (priceDisplay && btn.dataset.price) {
          priceDisplay.textContent = btn.dataset.price;
        }
        const sizeLabel = document.getElementById('price-size-label');
        if (sizeLabel && btn.dataset.size) {
          sizeLabel.textContent = btn.dataset.size;
        }
      });
    });
    // Respect HTML-pre-set active class; else default to first
    const pre = btns.find(b => b.classList.contains('active'));
    if (!pre && btns[0]) btns[0].classList.add('active');
    updatePrice(pre || btns[0]);
  });
}

/* ── Filter bar ── */
function initFilters() {
  $$('.filter-bar').forEach(bar => {
    const btns = $$('.filter-btn', bar);
    const grid = bar.nextElementSibling;
    btns.forEach(btn => {
      on(btn, 'click', () => {
        btns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        const filter = btn.dataset.filter;
        if (!grid) return;
        $$('[data-filter-item]', grid).forEach(item => {
          if (filter === 'all') {
            item.style.display = '';
          } else {
            item.style.display = item.dataset.filterItem?.includes(filter) ? '' : 'none';
          }
        });
      });
    });
  });
}

/* ── Email popup ── */
function initEmailPopup() {
  const popup = $('.email-popup');
  const close = $('.email-popup__close');
  if (!popup) return;

  const hasSeenPopup = sessionStorage.getItem('sl_popup_seen');
  if (hasSeenPopup) return;

  const show = () => { popup.classList.add('open'); };
  const hide = () => {
    popup.classList.remove('open');
    sessionStorage.setItem('sl_popup_seen', '1');
  };

  // Trigger on 8s or exit intent
  const timer = setTimeout(show, 8000);
  on(document, 'mouseleave', e => { if (e.clientY < 0) { clearTimeout(timer); show(); } });
  on(close, 'click', hide);

  // Form submit
  const form = popup.querySelector('.email-form');
  on(form, 'submit', e => {
    e.preventDefault();
    hide();
    // Shopify form submission handled by theme
  });
}

/* ── Sticky ATC (mobile product page) ── */
function initStickyATC() {
  const sticky = $('.sticky-atc');
  const atcSection = $('.product-actions');
  if (!sticky || !atcSection) return;

  const io = new IntersectionObserver(entries => {
    sticky.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0 });
  io.observe(atcSection);
}

/* ── Quiz ── */
function initQuiz() {
  const quiz = $('.quiz-container');
  if (!quiz) return;

  let current = 0;
  const questions = $$('.quiz-step[data-step]', quiz);
  const progress = $$('.quiz-progress__dot', quiz);

  const showStep = (idx) => {
    questions.forEach((q, i) => {
      q.style.display = i === idx ? 'block' : 'none';
    });
    progress.forEach((dot, i) => {
      dot.classList.toggle('done', i < idx);
    });
  };

  showStep(0);

  $$('.quiz-answer', quiz).forEach(answer => {
    on(answer, 'click', () => {
      const siblings = $$('.quiz-answer', answer.closest('.quiz-answers'));
      siblings.forEach(s => s.classList.remove('selected'));
      answer.classList.add('selected');

      setTimeout(() => {
        if (current < questions.length - 1) {
          current++;
          showStep(current);
        }
      }, 400);
    });
  });
}

/* ── Announcement marquee duplicate ── */
function initMarquee() {
  const track = $('.announcement-bar__track');
  if (!track) return;
  // Duplicate content for seamless loop
  track.innerHTML += track.innerHTML;
}

/* ── Scroll reveal for hero ── */
function initHeroParallax() {
  const heroBg = $('.hero__bg-image');
  if (!heroBg || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  on(window, 'scroll', () => {
    const y = window.scrollY;
    heroBg.style.transform = `translateY(${y * 0.3}px)`;
  }, { passive: true });
}

/* ── Cart: quantity change & remove ── */
async function changeCartItemQty(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  });
  updateCartCount();
}

on(document, 'click', async (e) => {
  // Remove entirely
  const removeBtn = e.target.closest('[data-remove-item]');
  if (removeBtn) {
    await changeCartItemQty(removeBtn.dataset.removeItem, 0);
    return;
  }
  // Decrease
  const minusBtn = e.target.closest('[data-qty-minus]');
  if (minusBtn) {
    const item = minusBtn.closest('.cart-item');
    const qtyEl = item?.querySelector('.cart-item__qty-num');
    const current = parseInt(qtyEl?.textContent || '1', 10);
    await changeCartItemQty(minusBtn.dataset.qtyMinus, Math.max(0, current - 1));
    return;
  }
  // Increase
  const plusBtn = e.target.closest('[data-qty-plus]');
  if (plusBtn) {
    const item = plusBtn.closest('.cart-item');
    const qtyEl = item?.querySelector('.cart-item__qty-num');
    const current = parseInt(qtyEl?.textContent || '1', 10);
    await changeCartItemQty(plusBtn.dataset.qtyPlus, current + 1);
  }
});

/* ── Cart: update count + render drawer items ── */
async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    $$('.cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    updateShippingProgress(cart.total_price);
    renderCartItems(cart);
  } catch (e) {}
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

function renderCartItems(cart) {
  const body  = document.getElementById('cart-items-wrap') || document.getElementById('cart-drawer-body');
  const empty = document.getElementById('cart-empty');
  const total = document.getElementById('cart-total-amount');
  if (!body) return;

  if (total) total.textContent = formatMoney(cart.total_price);

  if (!cart.items || cart.items.length === 0) {
    if (empty) empty.style.display = '';
    $$('.cart-item', body).forEach(el => el.remove());
    return;
  }

  if (empty) empty.style.display = 'none';

  const html = cart.items.map(item => {
    const imgSrc = item.image ? item.image.replace(/(\.\w+)(\?.*)?$/, '_80x80$1') : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<span class="cart-item__variant">${item.variant_title}</span>` : '';
    const img = imgSrc
      ? `<img src="${imgSrc}" alt="" class="cart-item__img" width="64" height="64" loading="lazy">`
      : `<div class="cart-item__img cart-item__img--placeholder"></div>`;
    return `<div class="cart-item" data-key="${item.key}">
      <a href="${item.url}" class="cart-item__image-link">${img}</a>
      <div class="cart-item__details">
        <a href="${item.url}" class="cart-item__name">${item.product_title}</a>
        ${variant}
        <div class="cart-item__bottom">
          <div class="cart-item__qty-controls">
            <button class="cart-item__qty-btn" data-qty-minus="${item.key}" aria-label="Decrease quantity">−</button>
            <span class="cart-item__qty-num">${item.quantity}</span>
            <button class="cart-item__qty-btn" data-qty-plus="${item.key}" aria-label="Increase quantity">+</button>
          </div>
          <span class="cart-item__price">${formatMoney(item.line_price)}</span>
        </div>
        <button class="cart-item__remove" data-remove-item="${item.key}" aria-label="Remove item">Remove</button>
      </div>
    </div>`;
  }).join('');

  $$('.cart-item', body).forEach(el => el.remove());
  body.insertAdjacentHTML('afterbegin', html);
}

function updateShippingProgress(totalCents) {
  const threshold = 7500; // $75 CAD in cents
  const fill = $('.shipping-progress__fill');
  const text = $('.shipping-progress__text');
  if (!fill) return;
  const pct = Math.min((totalCents / threshold) * 100, 100);
  fill.style.width = pct + '%';
  if (text) {
    if (totalCents >= threshold) {
      text.textContent = 'Free shipping unlocked!';
    } else {
      const remaining = ((threshold - totalCents) / 100).toFixed(2);
      text.textContent = `$${remaining} away from free shipping`;
    }
  }
}

/* ── ATC form: add personalization ── */
on(document, 'submit', async (e) => {
  const form = e.target.closest('[data-atc-form]');
  if (!form) return;
  e.preventDefault();

  const btn = form.querySelector('[data-atc-btn]');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

  const nameInput = form.querySelector('.personalization__input');
  const variantId = form.querySelector('[name="id"]')?.value;
  const qty = form.querySelector('.quantity-input')?.value || 1;

  const properties = {};
  if (nameInput?.value.trim()) {
    properties['Personalized Name'] = nameInput.value.trim();
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: +qty, properties })
    });
    if (res.ok) {
      // Open cart drawer
      $('.cart-drawer')?.classList.add('open');
      $('.cart-drawer-overlay')?.classList.add('open');
      document.body.style.overflow = 'hidden';
      updateCartCount();
    }
  } catch (err) { console.error(err); }
  finally {
    if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
  }
});

/* ── Toast notification ── */
function showToast(msg, duration = 3500) {
  let toast = document.getElementById('sl-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'sl-toast';
    toast.className = 'sl-toast';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toast._t);
  toast._t = setTimeout(() => toast.classList.remove('show'), duration);
}

/* ── Decant: Add to Bag ── */
function initDecantATC() {
  on(document, 'click', e => {
    const btn = e.target.closest('[data-decant-atc]');
    if (!btn) return;
    const card = btn.closest('.decant-card');
    const name = btn.dataset.decantName || 'Decant';
    const activeSize = card?.querySelector('.size-btn.active');
    const size = activeSize?.dataset.size || '5ml';
    const price = activeSize?.dataset.price || '';
    const variantId = activeSize?.dataset.variantId || btn.dataset.variantId;

    const orig = btn.textContent;
    btn.classList.add('added');
    btn.textContent = '✓ Added';
    showToast(`${name} · ${size} ${price} — added to bag`);
    setTimeout(() => { btn.classList.remove('added'); btn.textContent = orig; }, 2500);

    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: { Fragrance: name, Size: size } })
      }).then(() => {
        updateCartCount();
        $('.cart-drawer')?.classList.add('open');
        $('.cart-drawer-overlay')?.classList.add('open');
        document.body.style.overflow = 'hidden';
      }).catch(() => {});
    }
  });
}

/* ── Viewing count (social proof urgency) ── */
function initViewingCount() {
  const el = document.getElementById('viewing-count-num');
  if (!el) return;
  const rand = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
  el.textContent = rand(4, 11);
  setInterval(() => {
    const current = parseInt(el.textContent, 10);
    const delta = rand(-2, 2);
    const next = Math.max(3, Math.min(14, current + delta));
    el.textContent = next;
  }, rand(35000, 55000));
}

/* ── Product Reviews ── */
function initProductReviews() {
  const toggle     = $('#write-review-toggle');
  const wrap       = $('#write-review-wrap');
  const form       = $('#review-contact-form');
  const successEl  = $('#review-success');
  const formInner  = $('#review-form-inner');
  if (!toggle || !wrap) return;

  // Toggle form open/close
  function openForm() {
    wrap.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    toggle.textContent = 'Close';
    wrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function closeForm() {
    wrap.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Write a Review';
  }
  on(toggle, 'click', () => wrap.hidden ? openForm() : closeForm());
  $$('.write-review-cancel').forEach(btn => on(btn, 'click', closeForm));

  // Star picker
  const stars      = $$('.star-picker__star');
  const ratingInput = $('#review-rating-input');
  const ratingError = $('#rating-error');
  let selected = 0;

  function paintStars(upTo) {
    stars.forEach((s, i) => {
      s.classList.toggle('selected', i < upTo);
      s.classList.toggle('hovered', false);
    });
  }

  stars.forEach((star, idx) => {
    on(star, 'mouseenter', () => stars.forEach((s, i) => s.classList.toggle('hovered', i <= idx)));
    on(star, 'mouseleave', () => stars.forEach(s => s.classList.remove('hovered')));
    on(star, 'click', () => {
      selected = idx + 1;
      ratingInput.value = selected;
      paintStars(selected);
      if (ratingError) ratingError.hidden = true;
    });
  });

  // Photo upload
  const photoInput   = $('#review-photo');
  const placeholder  = $('#photo-placeholder');
  const previewWrap  = $('#photo-preview-wrap');
  const previewImg   = $('#photo-preview');
  const removeBtn    = $('#photo-remove');
  const photoDataInput = $('#review-photo-data');

  if (photoInput) {
    on(photoInput, 'change', () => {
      const file = photoInput.files[0];
      if (!file) return;
      const reader = new FileReader();
      reader.onload = e => {
        previewImg.src = e.target.result;
        placeholder.hidden = true;
        previewWrap.hidden = false;
        if (photoDataInput) photoDataInput.value = 'Photo attached: ' + file.name + ' (' + (file.size / 1024).toFixed(0) + 'KB)';
      };
      reader.readAsDataURL(file);
    });
    on(removeBtn, 'click', () => {
      photoInput.value = '';
      previewImg.src = '';
      placeholder.hidden = false;
      previewWrap.hidden = true;
      if (photoDataInput) photoDataInput.value = '';
    });
  }

  // Form submission
  if (!form) return;
  on(form, 'submit', e => {
    let valid = true;

    // Validate rating
    if (!ratingInput.value) {
      e.preventDefault();
      if (ratingError) ratingError.hidden = false;
      valid = false;
    }

    // Validate required fields
    const name  = $('#review-name');
    const email = $('#review-email');
    const body  = $('#review-body');
    [name, email, body].forEach(f => {
      if (f && !f.value.trim()) { f.style.borderColor = '#c00'; valid = false; }
      else if (f) f.style.borderColor = '';
    });

    if (!valid) { e.preventDefault(); return; }

    // Show success state after short delay (form posts and page reloads normally,
    // but if JS intercepts we show confirmation)
    e.preventDefault();
    const submitBtn = $('#review-submit');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Submitting…'; }

    // Build and submit via fetch so we stay on the page
    const data = new FormData(form);
    fetch(form.action, { method: 'POST', body: data })
      .then(() => {
        if (formInner) formInner.hidden = true;
        if (successEl) successEl.hidden = false;
      })
      .catch(() => {
        // Fallback: just show success anyway (contact form likely succeeded)
        if (formInner) formInner.hidden = true;
        if (successEl) successEl.hidden = false;
      });
  });
}

/* ── Init all ── */
document.addEventListener('DOMContentLoaded', () => {
  initFadeIn();
  initHeader();
  initMobileNav();
  initCartDrawer();
  initQuantity();
  initTabs();
  initSizeSelector();
  initFilters();
  initEmailPopup();
  initStickyATC();
  initQuiz();
  initMarquee();
  initHeroParallax();
  initDecantATC();
  initViewingCount();
  updateCartCount();
  initProductReviews();
});
